import {ReviewService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced:true,
    state:{
        forms:[]
    },
    mutations:{
        saveWaitingForms(current, forms) {
            current.forms.splice(0);
            current.forms = forms;
        }
    },

    actions:{
        async getWaitingFormsAction({dispatch, commit}) {
            await bindLoading(commit, async () => commit('saveWaitingForms', await ReviewService.getWaitingForm()), 'review')
        },

        async signAction({commit, state}, id){
            return await bindLoading(commit, async () => {
                const {success, messages, instance} = await ReviewService.sign(id);
                if(success){
                    const newForms = state.forms.filter(h => h.id !== instance);
                    commit('saveWaitingForms', newForms);
                }
                return {success, messages};
            }, 'review');
        },
        async signAllAction({ commit, state}, ids){
            return await bindLoading(commit, async () => {
                const {success, messages, instance} = await ReviewService.signAll(ids);
                if(success){
                    const newForms = state.forms.filter(h => !instance.some(i => h.id === i));
                    commit('saveWaitingForms', newForms);
                }
                return {success, messages};
            }, 'review')
        },
        async denyAction({ commit, state}, reason){
            return await bindLoading(commit, async () => {
                const {success, messages, instance} = await ReviewService.deny(reason);
                if(success){
                    const newForms = state.forms.filter(h => h.id !== instance);
                    commit('saveWaitingForms', newForms);
                }
                return {success, messages};
            }, 'review')
        }
    }

}